// extracted by mini-css-extract-plugin
export var root = "_zh-0";
export var scroll = "_zh-1";
export var thumb = "_zh-3";
export var track = "_zh-2";